<h3 class="font-bold text-lg">Filialinfo bearbeiten</h3>

@if (isEmpty) {
  <p class="text-sm opacity-70">Noch keine Stationen hinterlegt.</p>
}

@if (stations.length > 0) {
  <div class="flex flex-col gap-3">
    @for (group of stations.controls; track group.getRawValue().key; let i = $index) {
      <div class="bm-card bg-base-200 p-3" [formGroup]="group">
        <div class="flex flex-row items-center gap-2">
          <label class="bm-floating-label flex-1">
            <span class="bm-label">Bezeichnung</span>
            <input
              class="bm-input w-full"
              type="text"
              maxlength="80"
              formControlName="title"
              placeholder="z. B. Kasse 7"
            />
          </label>
          <label class="bm-floating-label">
            <span class="bm-label">Key</span>
            <input
              class="bm-input bm-input-sm w-32 font-mono"
              type="text"
              maxlength="40"
              formControlName="key"
              pattern="[a-z0-9_]+"
              placeholder="kasse7"
            />
          </label>
          <button
            type="button"
            class="bm-btn bm-btn-ghost bm-btn-sm"
            (click)="removeStation(i)"
            [attr.aria-label]="'Station ' + group.controls.key.value + ' entfernen'"
          >
            Entfernen
          </button>
        </div>

        <div class="flex flex-row flex-wrap gap-4 mt-2">
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" class="bm-toggle" formControlName="tausche_kasse" />
            <span>Kasse tauschen</span>
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" class="bm-toggle" formControlName="tausche_drucker" />
            <span>Drucker tauschen</span>
          </label>
          <label class="flex items-center gap-2 cursor-pointer">
            <input type="checkbox" class="bm-toggle" formControlName="tausche_monitor" />
            <span>Monitor tauschen</span>
          </label>
        </div>
      </div>
    }
  </div>
}

@if (errorMessage()) {
  <div class="bm-alert bm-alert-error">
    <span class="fa fa-exclamation-triangle"></span>
    <span>{{ errorMessage() }}</span>
  </div>
}

<div class="flex flex-row items-center justify-between gap-2 mt-2">
  <button type="button" class="bm-btn bm-btn-secondary" (click)="addStation()">
    Station hinzufügen
  </button>
  <div class="flex flex-row gap-2">
    <button type="button" class="bm-btn" (click)="handleCancel()" [disabled]="isSaving()">
      Abbrechen
    </button>
    <button
      type="button"
      class="bm-btn bm-btn-primary"
      (click)="handleSave()"
      [disabled]="isSaving()"
    >
      Speichern
    </button>
  </div>
</div>
